var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"boxView",staticClass:"boxView",style:({'width':'100%','height':'310px'})},[_c('canvas',{staticClass:"monitor-canvas",attrs:{"id":_vm.canvasId,"width":_vm.canvasWidth,"height":_vm.canvasHeight}})])
}
var staticRenderFns = []

export { render, staticRenderFns }